import React, { Suspense, lazy } from "react";
import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import AdminRoute from "@/components/AdminRoute";
import Layout from "@/components/Layout";
import PageLoader from "@/components/PageLoader";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Product from "@/pages/Product";

const Wishlist = lazy(() => import("@/pages/Wishlist"));
const Cart = lazy(() => import("@/pages/Cart"));
const Checkout = lazy(() => import("@/pages/Checkout"));
const OrderConfirm = lazy(() => import("@/pages/OrderConfirm"));
const Login = lazy(() => import("@/pages/Login"));
const Account = lazy(() => import("@/pages/Account"));
const About = lazy(() => import("@/pages/About"));
const Policies = lazy(() => import("@/pages/Policies"));
const AdminLayout = lazy(() => import("@/pages/admin/AdminLayout"));
const Dashboard = lazy(() => import("@/pages/admin/Dashboard"));
const Products = lazy(() => import("@/pages/admin/Products"));
const ProductForm = lazy(() => import("@/pages/admin/ProductForm"));
const Users = lazy(() => import("@/pages/admin/Users"));
const Orders = lazy(() => import("@/pages/admin/Orders"));
const Newsletter = lazy(() => import("@/pages/admin/Newsletter"));
const Offers = lazy(() => import("@/pages/admin/Offers"));

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <StoreProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route element={<Layout />}>
                  <Route index element={<Home />} />
                  <Route path="category/:slug" element={<Category />} />
                  <Route path="category/:slug/*" element={<Category />} />
                  <Route path="search" element={<Category />} />
                  <Route path="product/:id" element={<Product />} />
                  <Route path="product/:id/*" element={<Product />} />
                  <Route path="wishlist" element={<Wishlist />} />
                  <Route path="cart" element={<Cart />} />
                  <Route path="checkout" element={<Checkout />} />
                  <Route path="order/:id" element={<OrderConfirm />} />
                  <Route path="login" element={<Login />} />
                  <Route path="register" element={<Login />} />
                  <Route path="account" element={<Account />} />
                  <Route path="about" element={<About />} />
                  <Route path="policies" element={<Policies />} />
                  <Route path="policies/:slug" element={<Policies />} />
                  <Route path="*" element={<Home />} />
                </Route>

                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminLayout />
                    </AdminRoute>
                  }
                >
                  <Route index element={<Dashboard />} />
                  <Route path="products" element={<Products />} />
                  <Route path="products/new" element={<ProductForm />} />
                  <Route path="products/:id/edit" element={<ProductForm />} />
                  <Route path="users" element={<Users />} />
                  <Route path="orders" element={<Orders />} />
                  <Route path="newsletter" element={<Newsletter />} />
                  <Route path="offers" element={<Offers />} />
                </Route>
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster position="bottom-right" theme="light" toastOptions={{ style: { background: "hsl(var(--background))", color: "hsl(var(--foreground))", border: "1px solid hsl(var(--border))", fontFamily: "Manrope, sans-serif" } }} />
        </StoreProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
